import axios from 'axios';
import { URL } from '@/utils/constants';
const request = axios.create({
  withCredentials: true,
});

request.interceptors.request.use((req) => {
  req.headers = {
    ...req.headers,
    'x-use-secondary-verify-sdk': 1,
  };
  return req;
});

request.interceptors.response.use((response) => {
  const data = response.data;
  if (data?.code === 0) {
    return data;
  } else {
    return Promise.reject(data);
  }
});

export const sendCode = async (data: Obj, params: Obj = {}) => {
  return request.post(URL.sendCode, data, {
    params,
  });
};

export const validateCode = async (data: Obj) => {
  return request.post(URL.validateCode, data);
};

export { request };
